<div class="container mt-5">
  <div class="row justify-content-center">
    <div class="col-md-6 col-lg-5">
      <div class="card">
        <div class="card-body">
          <h5 class="card-title text-center">Two-Factor Authentication</h5>

          <form (ngSubmit)="submitOtp()" autocomplete="off">
            <div class="form-group">
              <label for="otp">Enter OTP Code</label>
              <input type="text" id="otp" class="form-control" [(ngModel)]="otpCode" name="otpCode" maxlength="6" required />
            </div>

            <div *ngIf="errorMessage" class="alert alert-danger mt-2">
              {{ errorMessage }}
            </div>

            <div class="text-center mt-4">
              <button class="btn btn-primary btn-block" type="submit" [disabled]="isSubmitting || !otpCode">Verify</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
